import React from 'react'
import { isEmpty, isObject, map } from 'lodash'

import { stringIncludes } from '../../core/utils'

import TreeSelectNodeTitle from '../components/sections/tree-select-node-title'

const renderTreeSelectHighlightsForSearch = (options = [], searchValue = '') =>
  map(options, item => {
    const title = isObject(item.title) ? item.title?.props?.title : item.title

    return {
      ...item,
      ...(stringIncludes(title, searchValue)
        ? {
            title: (
              <TreeSelectNodeTitle
                title={title}
                searchValue={searchValue}
                isSticky={item.isSticky}
                isIgnored={item.isIgnoredItem}
                isDisabled={item.disabled}
              />
            ),
          }
        : {
            title: (
              <TreeSelectNodeTitle
                title={title}
                isSticky={item.isSticky}
                isIgnored={item.isIgnoredItem}
                isDisabled={item.disabled}
              />
            ),
          }),
      ...(!isEmpty(item.children) && {
        children: renderTreeSelectHighlightsForSearch(
          item.children,
          searchValue,
        ),
      }),
    }
  })

const handleTreeSelectDropdownSearchHighlights = origin => {
  const searchValue = origin?.props?.searchValue

  return {
    ...origin,
    props: {
      ...origin.props,
      options: renderTreeSelectHighlightsForSearch(
        origin.props.options,
        searchValue,
      ),
    },
  }
}

export default handleTreeSelectDropdownSearchHighlights
